import { StravaActivitiesView } from "src/components/StravaActivitiesPageStravaActivitiesView";
import { TableSearchProvider } from "src/components/TableSearchContext";

export const STRAVA_DEFAULT_PAGE_SIZE = 20;

export function StravaActivitiesPage() {
  return (
    <TableSearchProvider defaultPageSize={STRAVA_DEFAULT_PAGE_SIZE}>
      <StravaActivitiesView />
    </TableSearchProvider>
  );
}
